


















import moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  filters: {
    avatar: (value: string) => value.substring(0, 2).toUpperCase(),
    time: (value: string) => moment(value).fromNow()
  }
})
export default class CommentItem extends Vue {
  @Prop({ type: String }) text!: string;
  @Prop({ type: String }) author!: string;
  @Prop({ type: Boolean }) showAuthor!: boolean;
  @Prop({ type: String }) createdAt!: string;
  @Prop({ type: String }) type!: string;
  @Prop({ type: String, default: 'right' }) align!: string;

  get subline() {
    const date = moment(this.createdAt).fromNow();
    return this.showAuthor ? `${this.author} · ${date}` : date;
  }
}
